import { useMatches } from "react-router";
//#region src/modules/core/hooks/use-breadcrumbs.ts
var useBreadcrumbs = () => {
	return { crumbs: useMatches().filter((match) => Boolean(match.handle?.crumb)).map((match) => match.handle?.crumb?.()) };
};
//#endregion
export { useBreadcrumbs };
